import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { Switch } from "@material-ui/core";

import { _ } from "js/vendor";
import { PopupMenu, PopupMenuPaddedContainer } from "js/react/components/PopupMenu";
import { dialogTheme } from "js/react/materialThemeOverrides";
import { LabeledContainer } from "js/react/components/LabeledContainer";

export function AnimationSettingsMenu({ animations, setAnimationsValues }) {
    const animationIds = animations.map(({ id }) => id);
    const animationsEnabled = animations.some(animation => !animation.disabled);
    const waitForClick = animations.some(({ waitForClick }) => waitForClick);

    return (
        <PopupMenu
            id="animation-settings"
            icon="more_vert"
            showArrow={false}
            position="below"
            popupWidth={600}
            showHoverEffect={false}
        >
            <PopupMenuPaddedContainer>
                <MuiThemeProvider theme={dialogTheme}>
                    <LabeledContainer icon="play_circle_filled" label="Animate in" labelWidth={150} childrenContainerMinWidth={30}>
                        <Switch
                            name="animationsEnabled"
                            color="primary"
                            checked={animationsEnabled}
                            onChange={event => setAnimationsValues(event, animationIds, { disabled: !event.target.checked })}
                        />
                    </LabeledContainer>
                    <LabeledContainer icon="mouse" label="Click to advance" labelWidth={150} childrenContainerMinWidth={30}>
                        <Switch
                            name="waitForClick"
                            color="primary"
                            checked={waitForClick}
                            onChange={event => setAnimationsValues(event, animationIds, { waitForClick: event.target.checked })}
                        />
                    </LabeledContainer>
                </MuiThemeProvider>
            </PopupMenuPaddedContainer>
        </PopupMenu >
    );
}
